<template>
  <div class="onboarding-create-site__btn-next-steps">
    <button
      id="NextStep"
      @keyup.enter="nextStepBtn()"
      @click="nextStepBtn()"
      class="button is-primary is-big"
      :disabled="!isDisabled"
    >
      Avançar
    </button>
    <p
      v-if="showBtnJump()"
      class="onboarding-create-site__jump-all-steps"
      @click="clearStepLocalstorage()"
    >
      <router-link
        id="JumpNextStep"
        :to="{ path: `/onboarding/passo-${this.jumpStep()}` }"
        class="onboarding-create-site__jump-all-steps--link"
        >{{ getNameBtn() }}
      </router-link>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    stepNumber: Number,
    urlWedding: String,
    btnJumpInvisible: Boolean,
  },

  computed: {
    isDisabled: {
      get() {
        return this.$store.state.onboardingCreateSite.nextStep
      },

      set(payload) {
        this.$store.dispatch('setStep', payload)
      },
    },

    answerUser: {
      get() {
        return this.$store.state.onboardingCreateSite.answersOfStep
      },
      set(payload) {
        this.$store.dispatch('setAnswer', payload)
      },
    },
  },

  mounted() {
    this.getStepNumber() === 6 ? (this.isDisabled = true) : ''
  },

  methods: {
    showBtnJump() {
      return this.btnJumpInvisible ? false : true
    },

    getStepNumber() {
      const stepNumber = this.$route.params.id.split('-')
      return parseInt(stepNumber[1])
    },

    nextStepBtn() {
      this.isDisabled = false
      const indexStep = this.getStepNumber()

      let answerSteps = JSON.parse(
        localStorage.getItem(`onboarding_wed${this.answerUser.wed_id}`)
      )

      if (indexStep === 8) {
        answerSteps.website_url = this.answerUser.step8

        answerSteps.website_url
          ? localStorage.setItem(
              `onboarding_wed${this.answerUser.wed_id}`,
              JSON.stringify(answerSteps)
            )
          : ''
      }

      this.$router.push({ path: `/onboarding/passo-${this.stepNumber}` })
    },

    jumpStep() {
      if (this.stepNumber === 2 || this.stepNumber === 5) {
        return this.stepNumber + 1
      }
      if (this.stepNumber === 7) {
        this.isDisabled = true
        return this.stepNumber + 1
      }
      return this.stepNumber
    },

    getNameBtn() {
      if (this.stepNumber === 5) {
        return 'Editar depois'
      }
      if (this.stepNumber === 8) {
        return 'Escolher depois'
      }
      return 'Pular etapa'
    },

    clearStepLocalstorage() {
      let dataLocalstorage = JSON.parse(
        localStorage.getItem(`onboarding_wed${this.answerUser.wed_id}`)
      )

      if (!dataLocalstorage) {
        dataLocalstorage = {}
      }

      if (this.stepNumber === 2) {
        this.answerUser.step1 = null
        dataLocalstorage.couple_feeling = null
      }

      if (this.stepNumber === 4) {
        this.answerUser.step3 = null
        dataLocalstorage.website_goal = null
      }

      if (this.stepNumber === 5) {
        this.answerUser.step4 = null
        dataLocalstorage.website_pages = null
      }

      if (this.stepNumber === 8) {
        this.answerUser.step7 = null
        dataLocalstorage.gifts_type = null
      }

      if (this.stepNumber === 9) {
        dataLocalstorage.website_url = this.answerUser.step8
      }

      if (this.stepNumber === 10) {
        dataLocalstorage.website_theme = null
      }

      localStorage.setItem(
        `onboarding_wed${this.answerUser.wed_id}`,
        JSON.stringify(dataLocalstorage)
      )
    },
  },
}
</script>

<style lang="scss">
.onboarding-create-site {
  &__btn-next-steps {
    width: 100%;
  }

  &__jump-all-steps {
    margin-top: 10px;
    padding: 15px 6px;

    &--link {
      font-weight: bold;
      color: $gray-5;
      font-size: 18px;

      @media (min-width: $tablet) {
        font-size: 16px;
      }
    }
  }
}
</style>
